import type { AssignmentResultRow } from "./access-client";

/** Outcomes that mean the API had nothing to do for that location. */
const NO_CHANGE_OUTCOMES: ReadonlySet<string> = new Set(["unchanged", "not_assigned"]);

export const isNoChangeOutcome = (outcome: string): boolean => NO_CHANGE_OUTCOMES.has(outcome);

/**
 * Whether the call changed anything: `noChanges` when every row was a no-op
 * (already assigned / was not assigned), so a notice never claims an update
 * that did not happen. An empty list counts as no changes.
 */
export function summarizeAssignmentResults(
  results: readonly AssignmentResultRow[],
): "changed" | "noChanges" {
  return results.some((row) => !isNoChangeOutcome(row.outcome)) ? "changed" : "noChanges";
}
